import { Button, Text } from '@components'
import { Show, createSignal, onCleanup } from 'solid-js'
import { render } from 'solid-js/web'
import { Flex, Grid } from 'styled-system/jsx'
import { DialogContainer } from './DialogContainer'

export function appDialogConfirm(action: () => void, message: string): () => void {
	return () => {
		const [isOpen, setIsOpen] = createSignal(true)

		const onConfirm = () => {
			action()
			setIsOpen(false)
		}

		const onCancel = () => {
			setIsOpen(false)
		}

		const container = document.createElement('div')
		document.body.appendChild(container)

		const dispose = render(
			() => (
				<Show when={isOpen()}>
					<DialogContainer
						isOpen={isOpen()}
						setIsOpen={setIsOpen}
					>
						<Grid>
							<Text>{message}</Text>
							<Flex gap={2}>
								<Button
									variant="solid"
									colorPalette="tscGreen"
									onClick={onConfirm}
								>
									Confirm
								</Button>
								<Button
									variant="outline"
									colorPalette="current"
									onClick={onCancel}
								>
									Cancel
								</Button>
							</Flex>
						</Grid>
					</DialogContainer>
				</Show>
			),
			container,
		)

		onCleanup(() => {
			dispose()
			document.body.removeChild(container)
		})
	}
}
